export default "<div class=\"toggle-group\" [ngClass]=\"{'list-view': listView, 'min-width': enabledMinWidth}\">\n  <ng-content></ng-content>\n</div>\n"